import { AddressType } from "./address-type";

interface AddressData {
  id?: number;
  streetName?: string;
  buildingNumber?: string;
  addressAddition?: string;
  postcode?: string;
  city?: string;
  country?: string;
  addressTypeId?: number;
  athleteId?: number;
  coachId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  addressType?: AddressType;
}

export class Address {
  public static getNonTranslatableFields(): string[] { return ['id', 'streetName', 'buildingNumber', 'addressAddition', 'postcode', 'city', 'country', 'addressTypeId', 'athleteId', 'coachId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'streetName', 'buildingNumber', 'addressAddition', 'postcode', 'city', 'country', 'addressTypeId', 'athleteId', 'coachId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }


  id?: number;
  streetName?: string;
  buildingNumber?: string;
  addressAddition?: string;
  postcode?: string;
  city?: string;
  country?: string;
  addressTypeId?: number;
  athleteId?: number;
  coachId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  addressType?: AddressType;



  public static fromAPI(data: AddressData): Address {
    if(data.addressType) {
      data.addressType = AddressType.fromAPI(data.addressType);
    }
    return new Address(data);
  }

  public static fromAPIList(data: AddressData[]): Address[] {
    return data.map((item: AddressData) => Address.fromAPI(item));
  }

  constructor({id, streetName, buildingNumber, addressAddition, postcode, city, country, addressTypeId, athleteId, coachId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId,
              addressType} : AddressData) {
    this.id = id;
    this.streetName = streetName;
    this.buildingNumber = buildingNumber;
    this.addressAddition = addressAddition;
    this.postcode = postcode;
    this.city = city;
    this.country = country;
    this.addressTypeId = addressTypeId;
    this.athleteId = athleteId;
    this.coachId = coachId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;

    this.addressType = addressType;
  }

  public toJson(): Object {
    return {
      id: this.id,
      streetName: this.streetName,
      buildingNumber: this.buildingNumber,
      addressAddition: this.addressAddition,
      postcode: this.postcode,
      city: this.city,
      country: this.country,
      addressTypeId: this.addressTypeId,
      athleteId: this.athleteId,
      coachId: this.coachId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
